"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = require("prop-types");
const intl_1 = require("@kyruus/intl");
const VisitLabel_1 = __importDefault(require("./VisitLabel"));
const styles_1 = require("./styles");
const VisitTypes_1 = require("../../lib/constants/VisitTypes");
const messages_1 = __importDefault(require("../../lib/messages"));
const VideoType = ({ type }) => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(VisitLabel_1.default, { Wrapper: styles_1.VisitHeading, IconWrapper: styles_1.VideoIcon, iconSize: "24px", type: type }),
        react_1.default.createElement(styles_1.VisitContent, { "data-testid": "VisitTypeContent" },
            react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.appointmentVideoContent)))));
};
const PhoneType = ({ type }) => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(VisitLabel_1.default, { Wrapper: styles_1.VisitHeading, IconWrapper: styles_1.PhoneIcon, iconSize: "18px", type: type }),
        react_1.default.createElement(styles_1.VisitContent, { "data-testid": "VisitTypeContent" },
            react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.appointmentPhoneContent)))));
};
function VisitTypeContent({ type }) {
    switch (type) {
        case VisitTypes_1.PHONE:
            return react_1.default.createElement(PhoneType, { type: type });
        case VisitTypes_1.VIDEO:
            return react_1.default.createElement(VideoType, { type: type });
        default:
            return;
    }
}
exports.default = VisitTypeContent;
const propTypes = {
    type: prop_types_1.string // this always be one of them either 'video', 'phone' or 'in_person'
};
const defaultProps = {
    type: VisitTypes_1.IN_PERSON
};
VisitTypeContent.propTypes = propTypes;
VisitTypeContent.defaultProps = defaultProps;
//# sourceMappingURL=VisitTypeContent.js.map